import React from "react";
import Status from "../../../components/Visitor/Status/Status";

const StatusPage = () => {
  return (
    <div className="min-h-screen bg-charcoal-900 pt-20 pb-14 px-4 sm:px-6 overflow-hidden">
      <Status />
    </div>
  );
};

export default StatusPage;
